<template>
  <div>
    <v-stepper class='v-stepp' v-model="currentStep">
      <v-stepper-header class='v-stepp__header'>
        <template v-for="(step, index) in stepps">
          <v-stepper-step
            :key="'step_'+index"
            class="v-stepp__text"
            :class="index == 0 ? 'pl-0' : ''"
            :complete="step.complete"
            :editable="step.editable"
            edit-icon="$complete"
            color='secondary'
            :step="step.no"
            @click.stop="moveStep(step.to)"
          > {{step.text}}
          </v-stepper-step>
          <v-divider v-if="index+1 != stepps.length" :key="'divider'+index"></v-divider>
        </template>
      </v-stepper-header>
    </v-stepper>
  </div>
</template>

<script>
export default {
  props: {
    stepps:{
      require: true,
      type: Array,
    },
    disabled:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentStep: null,
      currentPath: this.$router.history.current.path
    }
  },
  mounted() {
    this.currentStep = this.stepps.findIndex(step => { return step.to === this.currentPath }) + 1;
  },
  methods:{
    moveStep(to) {
      if (this.disabled) return
      if (to === this.currentPath) return;
      this.$router.push(to);
    }
  }
}
</script>

<style lang="stylus" scoped>
.v-stepp
    box-shadow none

  &__header
    box-shadow none

.v-stepp__text
    font-size 12px

//vuetify側で指定しているcssを上書き(https://github.com/vuetifyjs/vuetify/blob/master/packages/vuetify/src/components/VStepper/VStepper.sass#L228)
//(画面幅960px以下になるとdisplay noneになっていた)
//参考１：https://vue-loader-v14.vuejs.org/ja/features/scoped-css.html
//参考２：https://blog.piyo.tech/posts/2018-10-23-vuejs-override-child-component-style/
.v-stepper >>> .v-stepper__label {
  display flex
}
.v-stepper >>> .v-stepper__step__step {
  margin-right 8px
}
</style>